import { format, isToday, isYesterday } from 'date-fns'
import { ptBR } from 'date-fns/locale'

/** Chave estável do dia (comparar mensagens adjacentes). */
export function chatMessageDayKey(date: Date): string {
  return format(date, 'yyyy-MM-dd')
}

/** Rótulo para separador: Hoje, Ontem ou data (dd/MM/yyyy). */
export function formatChatDayDividerLabel(date: Date): string {
  if (isToday(date)) return 'Hoje'
  if (isYesterday(date)) return 'Ontem'
  return format(date, 'dd/MM/yyyy', { locale: ptBR })
}
